import { OpacitySlider } from "../../controls/OpacitySlider";
import { ToolbarDivider } from "../../common/ToolbarDivider";
import { useTranslate } from "@refinedev/core";
import { DEFAULT_COLOR } from "../../../constants";
import { TemplateType } from "../../../types";
import { useTemplatesStatusStore } from "../../../store/useTemplatesStatusStore";
import { useTemplateEditorStore } from "../../../store/useTemplateEditorStore";
import { PlaceholderColorPicker } from "../../controls/PlaceholderColorPicker";
import {
  isGradient,
  resolveColorToBrandKitPlaceholder,
} from "../../../helpers/itemsHelper";
import type { GradientDefinition } from "types";
import { useTemplateData } from "../../../hooks/useTemplateData";

export const BackgroundControls = () => {
  const {
    brandKitData: { brandKitPalette: palette },
  } = useTemplateData();
  const t = useTranslate();

  const { background, setBackground, storeTransition, currentChapter } =
    useTemplateEditorStore((state) => ({
      background: state.templateState.background,
      setBackground: state.setBackground,
      storeTransition: state.templateState.transition,
      currentChapter: state.currentChapter,
    }));

  const { addTemplateUpdate } = useTemplatesStatusStore((state) => ({
    addTemplateUpdate: state.addTemplateUpdate,
  }));

  return (
    <>
      <PlaceholderColorPicker
        shape="round"
        title={t("components.templates.settings.bodyColor")}
        palette={palette}
        value={background.bodyColor}
        allowClear
        onClear={() => {
          setBackground({
            bodyColor: undefined,
          });
          addTemplateUpdate();
        }}
        disabledAlpha={true}
        showText={false}
        mode={["single", "gradient"]}
        onChangeComplete={(resolvedColor) => {
          if (isGradient(resolvedColor)) {
            setBackground({ bodyColor: resolvedColor });
            addTemplateUpdate();
            return;
          }

          const bodyView =
            currentChapter.type === TemplateType.CHAPTER
              ? background.bodyView
              : storeTransition.view;

          let finalColor: string | GradientDefinition | undefined =
            resolvedColor;

          if (bodyView !== "Color") {
            const originalColor = resolveColorToBrandKitPlaceholder(
              resolvedColor,
              palette
            );
            finalColor = `${originalColor}50`;
          }

          setBackground({
            bodyColor: finalColor,
          });
          addTemplateUpdate();
        }}
      />
      <ToolbarDivider />
      <OpacitySlider
        hexColor={
          isGradient(background.bodyColor)
            ? DEFAULT_COLOR
            : (background.bodyColor ?? DEFAULT_COLOR)
        }
        disabled={isGradient(background.bodyColor)}
        onChange={(value) => {
          setBackground({
            bodyColor: value,
          });
          addTemplateUpdate();
        }}
        containerStyle={{ paddingInlineStart: 8, maxHeight: "32px" }}
        palette={palette}
      />
    </>
  );
};
